export const printImage = (dataURL: string) => {
  const img = new Image();
  img.src = dataURL;
  img.onload = () => {
    const maxSize = 512;
    const { width, height } = img;
    let newWidth = width;
    let newHeight = height;

    if (width > maxSize || height > maxSize) {
      const widthRatio = maxSize / width;
      const heightRatio = maxSize / height;
      const minRatio = Math.min(widthRatio, heightRatio);
      newWidth = width * minRatio;
      newHeight = height * minRatio;
    }

    const style = [
      `padding: ${newHeight / 2}px ${newWidth / 2}px;`,
      `background: url(${dataURL}) no-repeat;`,
      `background-size: contain;`,
      `font-size: 1px;`
    ].join(' ');

    console.log('%c ', style);
  };
};
